export default __webpack_public_path__ + "static/media/727.2adf4466.png";